import React from 'react';
import './BottomBar.css';

export const BottomBar = ({ onCancel, onEnd }) => (
  <div className="ssr-bottom-bar">
    <button className="ssr-btn-cancel" onClick={onCancel}>
      Cancel
    </button>
    <button className="ssr-btn-end" onClick={onEnd}>
      End Session
    </button>
  </div>
);
